<template>
	<div class="site-main">
	    <slide :slide="slideData"></slide>
	    <news :news="newsData"></news>
	    <div class="article mb20 b-shadow">
	    	<div class="hd">
	    		<h3>最新动态</h3>
	    	</div>
	    	<div class="bd">
	    		<list :items="events"></list>
	    	</div>
	    </div>
	    <infinite-loading @infinite="onInfinite" ref="infiniteLoading" v-show="control == false">
      		<span slot="no-more">我是有底线的</span>
    	</infinite-loading>
    	<div class="more-btn" @click="loadMore" v-show="control == true">
	    	<img src="../common/images/more-icon.png" alt="加载更多">
	    </div>
	    <div class="app-fixed box align-center" v-show="appcontrol">
	    	<div class="close" @click="closeApp"><i class="iconfont icon-close"></i></div>
	    	<div class="content box align-center flex-1"> <div class="logo"><img src="../common/images/logo-img.png" alt="和数传媒"></div><div class="info"><h3>和数传媒 APP</h3><p>链接未来</p></div></div>
	    	<div class="downloadBtn"><a href="javascript:;" @click="openApp">打开APP</a></div>
	    </div>
    </div>
</template>

<script>
import slide from '../components/slide.vue'; 
import news from '../components/News.vue';
import list from '../components/List.vue';
import {setSEO,httpHead,apiUrl} from '../common/util/config.js';
import InfiniteLoading from 'vue-infinite-loading'
export default {
    data () {
        return {
        	slideData: [], //轮播
        	newsData: [], //新闻
        	events: [],  //最新动态
        	page: 0,    
        	totalPage: 0, //总页数
        	control:false, //滚动加载控制
        	pageSeo:{}, //seo内容
        	appUrl: '', // app下载地址
        	appcontrol: true //下载显示控制器
        }
    },
    created () {
    	var  u = navigator.userAgent;
		var  isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
		var  isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		if(isAndroid){
			this.appcontrol = true;
		}else{
			this.appcontrol = false
		}
    	if(window.appcontrol === undefined){
    		window.appcontrol = this.appcontrol;
    	}else{
			this.appcontrol = window.appcontrol;
    	}
    	this.$fetch('api/index')
    		.then(res => {
    			this.slideData = res.data.banner;
                this.newsData = res.data.policy;
                this.totalPage = res.data.list.last_page;
                this.pageSeo = res.data.seo;
                setSEO(this.pageSeo);
    		})
    	this.$fetch('api/version')
            .then(res => {
                this.appUrl=res.data.url;
            }) 
    },
    methods: {
    	onInfinite ($state) {
    		this.page++;
    		this.$fetch('api/index/page/'+this.page)
            .then(res => {
                this.events = this.events.concat(res.data.list.data);
                if(this.page > 2){
	                this.control = true;
                }
                if(this.control == false){
                	$state.loaded();
                }
                if(this.totalPage == this.page){
                	$state.complete();
                }
            })
            .catch(err => {
                console.log(err)
                $state.complete()
	        })
	    },
	    loadMore () {
	    	this.control = false;
	    	this.$nextTick(() => {
		        this.$refs.infiniteLoading.attemptLoad();
		    });
	    },
	    closeApp () {
	    	window.appcontrol = false;
	    	this.appcontrol = false;
	    },
	    openApp () {
	    	let ifr = document.createElement('iframe');
	    	ifr.src="heshu://media";
	    	ifr.style.display = 'none';
	    	let startTime = new Date();
	    	document.body.appendChild(ifr);
	    	let t = setTimeout(() => {
                let endTime = new Date();
                //指定的时间内没有跳转成功 当前页跳转到apk的下载地址
                if ((endTime - startTime) > 1800) {
                    window.location.href = this.appUrl;
                }
            },2000);
            window.onblur = function() {
                clearTimeout(t);
            }
	    }
    },
    components: {
    	slide,
    	news,
    	list,
    	InfiniteLoading
    }
}
</script>
<style lang="scss">
	.article {
		.hd {
			padding-top: .2rem;
		    height: .8rem;
		    padding: 0 .3rem;
		    border-bottom: 1px solid #f29316;
		    h3{
			    float: left;
			    height: .9rem;
			    line-height: .9rem;
			    font-size: .3rem;
			    color: #f29316;
		    }
		}
	}
	.app-fixed{
		position:fixed;
		bottom:0;
		left:0;
		right:0;
		background:#333;
		padding:.2rem .2rem;
		.close{
			margin-right:.4rem;
			.iconfont{
				font-size:.5rem;
				color:#999;
			}
		}
		.content{
			h3{
				color:#fff;
				font-size:.3rem;
				margin-bottom:.1rem
			}
			p{
				color:#eee;
			}
		}
		.logo{
			height:1rem ;
			width: 1rem;
			margin-right:.35rem;
			img{
				max-height:100%;
			}
		}
		.downloadBtn{
			a{
				display:inline-block;
				height: .55rem;
				line-height:.55rem;
				background:#1a5dad;
				color:#fff;
				padding:0 .3rem;
				border-radius:.05rem;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/homeView.vue